import "@workos-inc/widgets/styles.css";

import { ApiKeys, WorkOsWidgets } from "@workos-inc/widgets";

import { Card } from "@/components/ui/card";
import { useGetWidgetTokenQuery } from "@/data/queries";
import { WorkOSPermission } from "@/data/types";
import { WORKOS_WIDGETS_FONT_FAMILY } from "@/lib/styles";

// Key creation, listing and revocation are all handled by WorkOS. The widget
// is the only place the full key value is ever shown, so there is deliberately
// no custom UI here to reproduce or store it.
export const ApiKeysSection = () => {
  const { data: widgetAuth } = useGetWidgetTokenQuery([
    WorkOSPermission.WIDGET_API_KEYS_MANAGE,
  ]);

  return (
    <>
      <h3 className="scroll-m-20 text-2xl font-medium tracking-tight mt-8">
        API Keys
      </h3>

      <p className="mt-4">
        API keys authenticate requests to the Legitimate API on behalf of your
        organization. A key&apos;s value is shown only once, when it is created.
      </p>

      {widgetAuth && (
        <Card className="mt-6 p-6">
          <WorkOsWidgets
            className="!min-h-min"
            theme={{ fontFamily: WORKOS_WIDGETS_FONT_FAMILY }}
          >
            <ApiKeys authToken={widgetAuth?.token} />
          </WorkOsWidgets>
        </Card>
      )}
    </>
  );
};
